<template>

<Layout>
  <!-- 去掉多余信息 -->
  <div slot="nav"></div>
  <div slot="sub-nav"></div>
  <div slot="footer-service"></div>
  <!-- 去掉多余信息 -->

  <div class="home">

  <!-- 导航栏 -->

  <!-- banner -->
    <div class="banner">
      <div class="banner-box">
        <div class="banner-logo"></div>
        <div class="banner-title">
          <div class="banner-main-title" v-if="!isMobile">为什么是 <span> Google Cloud </span></div>
          <div class="banner-main-title" v-else>
            为什么是
            <br><span>Google Cloud</span>
          </div>
          <div class="banner-sub-title">突破性的解决方案  变革性的专业知识</div>
          <!-- <div class="banner-sub-title" v-else>突破性的解决方案<br>变革性的专业知识</div> -->
        </div>
      </div>
    </div>
  <!-- banner -->

  <!-- scroll -->
    <com-scroll :list-info="data['scroll']" />
  <!-- scroll -->

  <!-- 技术指南 -->
    <div id="guide" class="guide">
      <div class="container">
        <com-title :titleInfo="data['guide']['title']" />
        <div class="guide-content flex-content">
          <com-card1 :card-info="guideItem" v-for="(guideItem, guideIndex) in data['guide']['list']" :key="guideItem + '' + guideIndex" />
        </div>
        <!-- <com-button1 :selfClass="'normal'" :width="'200'" :button-info="data['guide']['button']" /> -->
      </div>
    </div>
  <!-- 技术指南 -->

  <!-- 问卷调查 -->
    <div class="questionnaire">
      <div class="container">
        <div class="content">
          <h1>{{ data['questionnaire']['title'] }}</h1>
          <com-button :selfClass="'normal'" :width="'200'" :button-info="data['questionnaire']['button']">
            <i slot="icon" class="iconfont iconarrow_forward_"></i>
          </com-button>
        </div>
      </div>
    </div>
  <!-- 问卷调查 -->

  <!-- 最新资讯 -->
    <div id="message" class="message">
      <div class="container">
        <img class="bg-right" src="../../assets/img/google-img/bg-right.png" alt="">
        <com-title :titleInfo="data['message']['title']" />
        <div class="message-content flex-content">
          <com-card2 :card-info="msgItem" v-for="(msgItem, msgIndex) in data['message']['list']" :key="msgItem + '-' + msgIndex" />
        </div>
        <!-- <com-button1 :button-info="data['message']['button']" /> -->
      </div>
    </div>
  <!-- 最新资讯 -->

  <!-- 精彩活动 -->
    <div id="activity" class="activity">
      <div class="container">
        <!-- <div class="common-title">
          <h1 style="font-size: 40px">{{ data.activity[0]['textInfo']['top']['mainTitle'] }}</h1>
          <h2>{{ data.activity[0]['textInfo']['top']['subTitle'] }}</h2>
        </div> -->
        <swiper :options="swiperOption">
          <swiper-slide v-for="(item, index) in data.activity" :key="index">
            <div style="display: flex">
              <div class="act-image" v-if="!isMobile">
                <img :src="item.imageList" alt="">
              </div>
              <div class="act-content">
                <div class="act-content-top">
                  <h1 style="font-size: 40px">{{ item['textInfo']['top']['mainTitle'] }}</h1>
                  <h2>{{ item['textInfo']['top']['subTitle'] }}</h2>
                </div>
                <div class="act-image" v-if="isMobile">
                  <img :src="item.imageList" alt="">
                </div>
                <div class="act-content-bottom">
                  <h1 class="title">{{ item['textInfo']['bottom']['title'] }}</h1>
                  <div class="timer-and-addr">
                    <i class="iconfont iconshijain"></i>
                    <span class="time">{{ item['textInfo']['bottom']['time'] }}</span>
                    <br v-if="isMobile"/>
                    <br v-if="isMobile"/>
                    <i class="iconfont icondidian"></i>
                    <span class="address">{{ item['textInfo']['bottom']['address'] }}</span>
                  </div>
                  <p class="text">{{ item['textInfo']['bottom']['text'] }}</p>
                </div>
                <div class="button-box">
                  <com-button :selfClass="'blue'" :width="'160'" :button-info="item['button']"></com-button>
                </div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <!-- <el-carousel style="width: 100%;cursor: pointer" :arrow="'hover'" :height="isMobile ? '820px' : '606px'" :loop="true" :interval="3000">
          <el-carousel-item v-for="(item, index) in data.activity" :key="index">
            <div style="display: flex">
              <div class="act-image" v-if="!isMobile">
                <img :src="item.imageList" alt="">
              </div>
              <div class="act-content">
                <div class="act-content-top">
                  <h1 style="font-size: 40px">{{ item['textInfo']['top']['mainTitle'] }}</h1>
                  <h2>{{ item['textInfo']['top']['subTitle'] }}</h2>
                </div>
                <div class="act-image" v-if="isMobile">
                  <img :src="item.imageList" alt="">
                </div>
                <div class="act-content-bottom">
                  <h1 class="title">{{ item['textInfo']['bottom']['title'] }}</h1>
                  <div class="timer-and-addr">
                    <i class="iconfont iconshijain"></i>
                    <span class="time">{{ item['textInfo']['bottom']['time'] }}</span>
                    <br v-if="isMobile"/>
                    <br v-if="isMobile"/>
                    <i class="iconfont icondidian"></i>
                    <span class="address">{{ item['textInfo']['bottom']['address'] }}</span>
                  </div>
                  <p class="text">{{ item['textInfo']['bottom']['text'] }}</p>
                </div>
                <div class="button-box">
                  <com-button :selfClass="'blue'" :width="'160'" :button-info="item['button']"></com-button>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel> -->
      </div>
    </div>
  <!-- 精彩活动 -->

  <!-- 白皮书 -->
    <div id="whitePaper" class="whitePaper">
      <div class="container">
        <com-title :titleInfo="data['whitePaper']['title']" />
        <div class="whitePaper-content flex-content">
          <com-card3 :card-info="paperItem" v-for="(paperItem, paperIndex) in data['whitePaper']['list']" :key="paperItem + '' + paperIndex" />
        </div>
        <!-- <com-button1 :button-info="data['whitePaper']['button']" v-if="data['whitePaper']['button']['text']"/> -->
      </div>
    </div>
  <!-- 白皮书 -->

  <!-- 客户案例 -->
    <div id="case" class="case">
      <div class="container">
        <img class="bg-left" src="../../assets/img/google-img/bg-left.png" alt="">
        <com-title :titleInfo="data['case']['title']" />
        <div class="case-content">
          <div class="top-img">
            <com-card4 :card-info="caseItem1" v-for="(caseItem1, caseIndex1) in data['case']['listTop']" :key="caseItem1 + '1' + caseIndex1" />
          </div>
          <div class="bottom-img">
            <com-card5 :card-info="caseItem2" v-for="(caseItem2, caseIndex2) in data['case']['listBottom']" :key="caseItem2 + '2' + caseIndex2" />
          </div>
        </div>
        <!-- <com-button1 :button-info="data['case']['button']" v-if="data['case']['button']['text']"/> -->
      </div>
    </div>
  <!-- 客户案例 -->

  <!-- 合作伙伴 -->
    <div id="partner" class="partner" v-if="false">
      <div class="container">
        <com-title :titleInfo="data['partner']['title']" />
        <com-card6 :data="data['partner']['partners']" />
      </div>
    </div>
  <!-- 合作伙伴 -->

  <!-- footer -->
    <!-- <com-footer :footer-info="data['footer']" /> -->
  <!-- footer -->
  </div>
</Layout>
</template>

<script>
import data from '@/data'

import Layout from 'components/layout/Layout'

// import ComNav from '@/components/nav'
import ComTitle from '@/components/title'
import ComCard1 from '@/components/card1'
import ComCard2 from '@/components/card2'
import ComCard3 from '@/components/card3'
import ComCard4 from '@/components/card4'
import ComCard5 from '@/components/card5'
import ComCard6 from '@/components/card6'
// import ComFooter from '@/components/footer'
import ComScroll from '@/components/scroll'
import ComButton from '@/components/button1'
// import ComButton2 from '@/components/button2'

import { mapState } from 'vuex'

export default {
  components: {
    Layout,

    // ComNav,
    ComTitle,
    ComCard1,
    ComCard2,
    ComCard3,
    ComCard4,
    ComCard5,
    ComCard6,
    // ComFooter,
    ComScroll,
    ComButton
    // ComButton2
  },
  data () {
    return {
      data: data,
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        loop: true,
        grabCursor: true,
        speed: 1000,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        }
      }
    }
  },
  methods: {
  },
  mounted () {
  },
  computed: {
    ...mapState(['isMobile'])
  }
}
</script>

<style lang="scss">
@import '@/style/app.sass';

.home {
  padding-bottom: 30px;
  background-color: #fff;
}

.banner {
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../image/banner-pc.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 484px;

  @include mobile {
    height: 320px;
    // background-image: url('../../image/banner-mobile.png');
    background-size: cover;
  }

  >.banner-box {
    display: flex;
    flex-direction: column;
    align-items: center;

    >.banner-logo {
      width: 192px;
      height: 30px;
      margin-bottom: 38px;
      background-image: url('../../image/logo.png');
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
      @include mobile {
        // display: none;
        width: 172px;
      }
    }

    >.banner-title {
      text-align: center;
      @include mobile {
        padding: 0 20px;
      }

      >.banner-main-title {
        font-size: 56px;
        font-weight:500;
        margin-bottom: 10px;
        color: $font-color1;
        font-family: PingFang SC;
        @include mobile {
          font-size: 40px;
          line-height: 44px;
        }
      }

      >.banner-sub-title {
        font-size: 27px;
        font-weight:400;
        color: $font-color2;
        font-family: PingFang SC;
        @include mobile {
          margin-top: 30px;
          font-size: 18px;
        }
      }
    }
  }
}

.guide {
  & .guide-content {
    display: flex;
    justify-content: space-between;
  }
}

.questionnaire {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 72px;
  height: 240px;
  background-color: $primary1;
  background-image: url('../../image/bg.png');
  background-size: cover;
  @include mobile {
    margin-top: 30px;
  }
  & .container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    // background-image: url('../../image/bg.png');
    // background-position: center top;
    // background-image: url('../../image/bg.png');
    & .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      & h1 {
        margin-bottom: 33px;
        color: #fff;
        font-size: $fontSize44;
        line-height: 1;
        font-weight: 500;
      }
    }
  }
}

@include mobile {
  .questionnaire {
    height: auto;
    background-color: $primary1;
    display: flex;
    align-items: center;
    >.container {
      padding: 40px 0;
      background-size: cover;
      background-image: url('../../image/bg-mobile.png');
      display: flex;
      align-items: center;
      justify-content: center;
      >.content {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0;
        text-align: center;
        >h1 {
          color: #fff;
          font-size: 25px;
          line-height: 30px;
          font-weight: 500;
          margin-bottom: 30px;
        }
        & > .button-box {
          margin-top: 0px;
        }
      }
    }
  }
}

.message {
  @include mobile {
    padding-bottom: 30px;
  }
  & .container {
    position: relative;
    .bg-right {
      position: absolute;
      right: -200px; top: 100px;
      width: 137px;
      @include mobile {
        display: none;
      }
    }
    & .message-content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    & .message-box:last-child {
      margin-bottom: 10px;
    }
  }
}

.activity {
  // height: 472px;
  padding: 100px 0 75px;
  @include mobile {
    padding-top: 30px;
    padding-bottom: 20px;
  }
  & .container {
    display: flex;
    position: relative;
    height: 100%;
    @include mobile {
      display: block;
    }
    .swiper-container {
      padding-bottom: 30px;
    }
    .swiper-pagination-bullets {
      width: 40%;
      right: 67px; left: auto;
      text-align: left;
      span {
        position: relative;
        width: 140px;
        height: 2px;
        border-radius: 4px;
        background: #333;
        &::before {
          content: '';
          position: absolute; top: -15px; left: 0;
          width: 100%;
          height: 30px;
          background: transparent;
        }
      }
      @include mobile {
        width: 100%;
        right: 0; left: auto; bottom: 0;
        text-align: center;
        span {
          width: 20%;
        }
      }
    }
    // & .common-title {
    //   position: absolute;
    //   top: 0; right: 0;
    // }
    .act-image {
      // flex: 1 1;
      // margin-right: 46px;
      @include mobile {
        // display: none;
        width: 100%;
        margin-bottom: 22px;
      }
      & img {
        width: 100%;
      }
      .image-box {
        position: relative;
        height: 100%;
        .image-item {
          position: absolute;
          // border: 1px solid red;
        }
        .image-top {
          left: 0;
          top: 0;
          z-index: 10;
          width: 300px;
          height: 300px;
        }
        .image-center {
          right: 0;
          top: 50%;
          z-index: 9;
          transform: translateY(-50%);
          width: 300px;
          height: 300px;
        }
        .image-bottom {
          left: 50%;
          bottom: 0;
          z-index: 10;
          transform: translateX(-50%);
          width: 200px;
          height: 150px;
        }
      }
    }
    .act-content {
      flex: none;
      width: 574px;
      // flex: 1 1;
      padding-left: 46px;
      //border: 1px solid green;
      @include mobile {
        width: 100%;
        padding: 0;
      }
      .act-content-top {
        margin-bottom: 40px;
        @include mobile {
          text-align: center;
        }
        h1 {
          line-height: 1;
          color: $font-color1;
          font-size: 36px;
          font-weight: 500;
          margin-bottom: 20px;
          @include mobile {
            font-size: 25px !important;
          }
        }
        h2 {
          letter-spacing: -1px;
          line-height: 1;
          color: $font-color2;
          font-size: $fontSize24;
          font-weight: 400;
          @include mobile {
            font-size: 17px !important;
            line-height: 1.3;
          }
        }
      }
      .act-content-bottom {
        margin-bottom: 28px;
        .title {
          line-height: 39px;
          color: $font-color1;
          font-size: 32px;
          font-weight: 500;
          margin-bottom: 36px;
          @include mobile {
            margin-bottom: 20px;
            line-height: 1.3;
            text-align: left;
            font-size: 20px;
          }
        }
        .timer-and-addr {
          line-height: 1;
          color: $font-color2;
          font-size: 16px;
          font-weight: 400;
          opacity: 0.9;
          margin-bottom: 35px;
          @include mobile {
            font-size: 14px;
            margin-bottom: 20px;
          }
          .time {
            margin-right: 23px;
          }
          .iconshijain, .icondidian {
            color: $primary1;
            font-size: 18px;
            margin-right: 8px;
          }
          @include mobile {
            .iconshijain {
              font-size: 15px;
            }
            .icondidian {
              font-size: 16px;
            }
          }
        }
        .text {
          // height: 90px;
          overflow: hidden;
          color: $font-color2;
          font-size: 16px;
          font-weight: 400;
          line-height: 26px;
          text-align: justify;
        }
      }
    }
  }
}

.whitePaper {
  padding-bottom: 75px;
  background-color: $bg-color;
  & .whitePaper-content {
    display: flex;
    justify-content: space-between;
    margin: 0 76px;
  }
  @include mobile {
    padding-bottom: 20px;
    & .whitePaper-content {
      margin: 0 auto;
    }
  }
}

.case {
  & .container {
    position: relative;
    .bg-left {
      position: absolute;
      left: -230px; top: 80px;
      width: 241px;
      @include mobile {
        display: none;
      }
    }
  }
  & .case-content {
    & .top-img,
    & .bottom-img {
      display: flex;
      justify-content: space-between;
      @include mobile {
        flex-wrap: wrap;
      }
    }
    & .top-img {
      margin-bottom: 32px;
      @include mobile {
        margin-bottom: 0;
      }
    }
  }
}
</style>
